import { useQuery } from '@tanstack/react-query';
import { api } from '@shared/api/client';
import { BITRIX_STORE } from '@shared/api/endpoints';
import { useBitrix24 } from '@shared/hooks/useBitrix24';
import { useTelegramStatus } from '@features/settings/hooks/useTelegram';
import type { WeeklyTrendsResponse } from '@tailorcast/shared-types';

export function useWeeklyTrends() {
  const { isBitrix24 } = useBitrix24();
  const { data: telegramStatus } = useTelegramStatus();

  return useQuery({
    queryKey: ['weekly-trends'],
    queryFn: () => api.get<WeeklyTrendsResponse>(BITRIX_STORE.WEEKLY_TRENDS),
    enabled: isBitrix24 && telegramStatus?.linked === true,
    staleTime: 5 * 60_000,
  });
}
